export default __webpack_public_path__ + "static/media/7fd459947e9f2c55.32356daa6ceb5299319bbffdced90ba4.svg";